import Flux from 'flux'
import { Job } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

(function(){
  'use strict';
  // data
  // var postingProgressData = Job.PostingProgressData = {}; //may need for testing to access global
  var postingProgressData = {}

  // dispatcher
  var Dispatcher = new Flux.Dispatcher()

  // actions
  Job.PostingProgressActions = {
    track: false,
    updateTracking: function(val) {
      Dispatcher.dispatch({
        type: 'job:posting_progress:tracking_changed',
        value: val
      })
    },
    createPostingProgress: function() {
      Dispatcher.dispatch({
        type: 'job:posting_progress:create'
      })
    },
    storePostingProgress: function() {
      Dispatcher.dispatch({
        type: 'job:posting_progress:store'
      })
    },
    syncStoredPostingProgress: function() {
      Dispatcher.dispatch({
        type: 'job:posting_progress:sync'
      })
    }
  }

  // store
  Dispatcher.register(
    function(payload) {
      switch (payload.type) {
        case 'job:posting_progress:tracking_changed':
          $.extend(postingProgressData, payload.value)
          console.log(JSON.stringify(postingProgressData))
          break;
        case 'job:posting_progress:create':
          if(!location.host.includes('admin.') && Job.PostingProgressActions.track === true) {
            Job.Api.post('jobs_posting_progress', jobPostingProgressDataMapper());
          }
          break;
        case 'job:posting_progress:store':
          if(!location.host.includes('admin.') && Job.PostingProgressActions.track === true && localStorage) {
            localStorage.setItem('jobs_posting_progress', jobPostingProgressDataMapper())
          }
          break;
        case 'job:posting_progress:sync':
          if (localStorage && localStorage.getItem('jobs_posting_progress')) {
            Job.Api.post('jobs_posting_progress', localStorage.getItem('jobs_posting_progress'), function() {
              localStorage.removeItem('jobs_posting_progress')
            })
          }
          break;
      }
    }
  )

  // ajax helper
  function jobPostingProgressDataMapper() {
    return JSON.stringify(
      { data:
        { type: 'jobs-posting-progress',
          attributes: {
            'url':            postingProgressData.url,
            'source':         postingProgressData.source,
            'exit-type':      postingProgressData.exitType,
            'last-question':  postingProgressData.lastQuestion
          },
          relationships: {
            'job':      { data: { type: 'jobs',   id: postingProgressData.jobId }},
            'user':     { data: { type: 'users',  id: postingProgressData.userId }},
            'job-type': { data: { type: postingProgressData.categoryType, id: Job.Data.category_id }} //TODO this needs to change to Job.Data.category_type when category code gets updated @JM
           }
        }
      }
    )
  }

})()
